import { render } from "./Bbas.vue?vue&type=template&id=3d1b5c1c&scoped=true"
import script from "./Bbas.vue?vue&type=script&lang=js"
export * from "./Bbas.vue?vue&type=script&lang=js"

import "./Bbas.vue?vue&type=style&index=0&id=3d1b5c1c&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1b5c1c"]])

export default __exports__